<template lang="pug">
    //- section#bannerEgressos
    //-     div.img
    //-         img(:src="require('@images/egressos/banner_egressos.jpg')", alt="").desktop
    //-         img(:src="require('@images/egressos/banner_egressos_mobile.jpg')", alt="").mobile
</template>

<script>
export default {
    name: "component-banner-egressos"
}
</script>

<style lang="stylus" scoped src="./BannerEgressos.styl"></style>